/**
 * This is the starting point of your application.
 * Feature Hub Apps will use this file to bootstrap the app.
 */
import React, { useEffect, useState } from 'react';

import { Providers } from './components/Providers';
import { App } from './components/App';
import { fetchCaeEnforcement } from './marketCompliance';

export const FeatureApp: React.FC<FeatureAppProps> = ({
  children,
  serviceLocale,
  serviceFootnote,
  serviceI18n,
  serviceTracking,
  serviceContent,
  serviceVueFormatter,
  gfaServiceConfigProvider,
  isMarketComplianceEnabled,
  initialWltpCompliance,
  logger,
}: FeatureAppProps) => {
  const [content, setContent] = useState(serviceContent?.getContent() as unknown as ContentAem);

  // `isMarketComplianceEnabled` is provided by SSR pre-check; on the client we
  // fetch the ACS flag asynchronously via the gfa service config provider.
  const [complianceEnabled, setComplianceEnabled] = useState<boolean>(
    isMarketComplianceEnabled ?? false,
  );

  useEffect(() => {
    serviceContent?.onContentChange(() => {
      setContent(serviceContent.getContent() as ContentAem);
    });
  }, [serviceContent]);

  useEffect(() => {
    if (isMarketComplianceEnabled !== undefined) return undefined;

    let cancelled = false;
    fetchCaeEnforcement({ gfaServiceConfigProvider })
      .then((result) => {
        if (!cancelled) setComplianceEnabled(result.caeDataRequired);
      })
      .catch(() => {
        // Error fetching CAE enforcement
      });
    return () => {
      cancelled = true;
    };
  }, [gfaServiceConfigProvider, isMarketComplianceEnabled]);

  return (
    <div data-fake-update="1" data-testid="FeatureApp" className="fa-carousel">
      <Providers
        i18nData={serviceI18n}
        i18nLanguage={serviceLocale.language}
        serviceLocale={serviceLocale}
        serviceVueFormatter={serviceVueFormatter}
        serviceTracking={serviceTracking}
        serviceFootnote={serviceFootnote}
        content={content}
      >
        {children}
        <App
          isMarketComplianceEnabled={complianceEnabled}
          initialCompliance={initialWltpCompliance}
          logger={logger}
        />
      </Providers>
    </div>
  );
};

export default FeatureApp;
